import React, { Component } from 'react'
import {
    FormControl,
    FormControlLabel,
    Checkbox,
    Box,
    Select,
    MenuItem,
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle, faTimes, faPlus } from '@fortawesome/pro-duotone-svg-icons'
import { CompactButton } from '@/shared/ui/buttons'

class DisplayItemDateSettings extends Component {
    constructor(props) {
        super(props)

        this.state = {
            show_slider:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.show_slider
                    ? true
                    : false,
            show_ago:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.show_ago
                    : null,
            deadline:
                this.props.item &&
                this.props.item.settings &&
                Array.isArray(this.props.item.settings.deadline) &&
                this.props.item.settings.deadline.length > 0
                    ? this.props.item.settings.deadline
                    : null,
            showColorPicker: false,
            default_current_date:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.default_current_date
                    : null,
        }

        this.addFieldToDate = this.addFieldToDate.bind(this)
        this.removeFieldFromDate = this.removeFieldFromDate.bind(this)
        this.deadlineDate = this.deadlineDate.bind(this)
    }

    addFieldToDate() {
        const newField = { number: 1, type: 'day', when: 'before', color: '' }
        let deadline = this.state.deadline
        if (!Array.isArray(deadline)) {
            deadline = []
        }
        deadline.push(newField)

        this.setState({ deadline: deadline })
        this.props.onChange('deadline', deadline)
    }

    removeFieldFromDate(index) {
        let deadline = this.state.deadline
        deadline.splice(index, 1)
        this.setState({ deadline: deadline })
        this.props.onChange('deadline', deadline)
    }

    deadlineDate(index) {
        const typesSingular = [
            { type: 'Day', value: 'day' },
            { type: 'Week', value: 'week' },
            { type: 'Month', value: 'month' },
            { type: 'year', value: 'year' },
        ]

        const typesPlural = [
            { type: 'days', value: 'day' },
            { type: 'Weeks', value: 'week' },
            { type: 'Months', value: 'month' },
            { type: 'Years', value: 'year' },
        ]

        return (
            <Box>
                <Box display="flex" alignItems="center" gap={2}>
                    <FontAwesomeIcon
                        color={this.state.deadline[index].color}
                        style={{ cursor: 'pointer' }}
                        icon={faCircle}
                        onClick={() => this.toggleColorPicker()}
                    />
                    <input
                        type="color"
                        value={this.state.deadline[index].color}
                        onChange={(e) =>
                            this.handleColorChange(index, e.target.value)
                        }
                        title="Choose your color"
                        style={{
                            display: this.state.showColorPicker
                                ? 'block'
                                : 'none',
                        }}
                        disabled={this.props.disabled}
                    />{' '}
                    {`#${index + 1} ${this.props.kedo.t('reminder')}`}
                </Box>
                <Box display="flex" alignItems="center" gap={1}>
                    <FormControl fullWidth sx={{ maxWidth: '200px' }}>
                        <Select
                            displayEmpty
                            size="small"
                            onChange={(e) => {
                                const updatedDeadline = this.state.deadline.map(
                                    (item, i) => {
                                        if (i === index) {
                                            return {
                                                ...item,
                                                number: parseInt(
                                                    e.target.value
                                                ),
                                            }
                                        }
                                        return item
                                    }
                                )

                                this.setState({ deadline: updatedDeadline })
                                this.props.onChange('deadline', updatedDeadline)
                            }}
                            value={this.state.deadline[index].number}
                            disabled={this.props.disabled}
                        >
                            {Array.from({ length: 31 }, (_, index) => (
                                <MenuItem value={index + 1} key={index + 1}>
                                    {index + 1}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth sx={{ maxWidth: '200px' }}>
                        <Select
                            displayEmpty
                            size="small"
                            onChange={(e) => {
                                const updatedDeadline = this.state.deadline.map(
                                    (item, i) => {
                                        if (i === index) {
                                            return {
                                                ...item,
                                                type: e.target.value,
                                            }
                                        }
                                        return item
                                    }
                                )

                                this.setState({ deadline: updatedDeadline })
                                this.props.onChange('deadline', updatedDeadline)
                            }}
                            value={this.state.deadline[index].type}
                            disabled={this.props.disabled}
                        >
                            {this.state.deadline.map((item, i) => {
                                if (item.number === 1 && i === index) {
                                    return typesSingular.map((type) => (
                                        <MenuItem
                                            value={type.value}
                                            key={type.value}
                                        >
                                            {this.props.kedo.t(type.type)}
                                        </MenuItem>
                                    ))
                                } else if (item.number > 1 && i === index) {
                                    return typesPlural.map((type) => (
                                        <MenuItem
                                            value={type.value}
                                            key={type.value}
                                        >
                                            {this.props.kedo.t(type.type)}
                                        </MenuItem>
                                    ))
                                }
                                return null
                            })}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth sx={{ maxWidth: '200px' }}>
                        <Select
                            size="small"
                            displayEmpty
                            onChange={(e) => {
                                const updatedDeadline = this.state.deadline.map(
                                    (item, i) => {
                                        if (i === index) {
                                            return {
                                                ...item,
                                                when: e.target.value,
                                            }
                                        }
                                        return item
                                    }
                                )

                                this.setState({ deadline: updatedDeadline })
                                this.props.onChange('deadline', updatedDeadline)
                            }}
                            value={
                                this.state.deadline[index].when === 'from now'
                                    ? 'before'
                                    : this.state.deadline[index].when ||
                                      'before'
                            }
                            disabled={this.props.disabled}
                        >
                            <MenuItem value="before">
                                {this.props.kedo.t('time_before')}
                            </MenuItem>
                            <MenuItem value="after">
                                {this.props.kedo.t('time_after')}
                            </MenuItem>
                        </Select>
                    </FormControl>
                    <CompactButton
                        variant="outlined"
                        color="error"
                        invert
                        onClick={() => {
                            if (this.props.disabled) return
                            this.removeFieldFromDate(index)
                        }}
                        id="button-addon4"
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </CompactButton>
                </Box>
            </Box>
        )
    }

    handleColorChange = (index, color) => {
        const updatedDeadline = this.state.deadline.map((item, i) => {
            if (i === index) {
                return { ...item, color: color }
            }
            return item
        })

        this.setState({ deadline: updatedDeadline })
        this.props.onChange('deadline', updatedDeadline)
    }

    toggleColorPicker() {
        this.setState({ showColorPicker: !this.state.showColorPicker })
    }

    render() {
        return (
            <div>
                <h3>{this.props.kedo.t('Settings')}</h3>
                <FormControl fullWidth margin="normal">
                    <FormControlLabel
                        control={
                            <Checkbox
                                size="small"
                                checked={this.state.show_slider}
                                onChange={(e) => {
                                    this.setState({
                                        show_slider: e.target.checked,
                                    })
                                    this.props.onChange(
                                        'show_slider',
                                        e.target.checked
                                    )
                                }}
                                disabled={this.props.disabled}
                            />
                        }
                        label={this.props.kedo.t('Show slider')}
                        sx={{
                            mb: 0,
                            '& .MuiFormControlLabel-label': {
                                fontSize: '0.875rem',
                                color: 'text.primary',
                            },
                        }}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                size="small"
                                checked={this.state.show_ago === true}
                                onChange={(e) => {
                                    this.setState({
                                        show_ago: e.target.checked,
                                    })
                                    this.props.onChange(
                                        'show_ago',
                                        e.target.checked
                                    )
                                }}
                                disabled={this.props.disabled}
                            />
                        }
                        label={this.props.kedo.t('Show ago')}
                        sx={{
                            mb: 0,
                            '& .MuiFormControlLabel-label': {
                                fontSize: '0.875rem',
                                color: 'text.primary',
                            },
                        }}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                size="small"
                                checked={this.state.deadline != null}
                                onChange={(e) => {
                                    const data = e.target.checked ? [] : null
                                    this.setState({ deadline: data })
                                    this.props.onChange('deadline', data)
                                }}
                                disabled={this.props.disabled}
                            />
                        }
                        label={
                            this.state.deadline ? (
                                <Box display="flex" alignItems="center" gap={1}>
                                    {this.props.kedo.t('Deadline')}
                                    <CompactButton
                                        dense
                                        onClick={() => this.addFieldToDate()}
                                        disabled={this.props.disabled}
                                    >
                                        <FontAwesomeIcon
                                            size="xs"
                                            icon={faPlus}
                                        />
                                    </CompactButton>
                                </Box>
                            ) : (
                                this.props.kedo.t('Deadline')
                            )
                        }
                        sx={{
                            mb: 0,
                            '& .MuiFormControlLabel-label': {
                                fontSize: '0.875rem',
                                color: 'text.primary',
                            },
                        }}
                    />
                    {this.state.deadline != null ? (
                        <>
                            {this.state.deadline?.length > 0 &&
                                this.state.deadline.map((item, index) => (
                                    <Box key={index} sx={{ mb: 2 }}>
                                        {this.deadlineDate(index)}
                                    </Box>
                                ))}
                        </>
                    ) : null}
                    <FormControlLabel
                        control={
                            <Checkbox
                                size="small"
                                checked={
                                    this.state.default_current_date === true
                                }
                                onChange={(e) => {
                                    this.setState({
                                        default_current_date: e.target.checked,
                                    })
                                    this.props.onChange(
                                        'default_current_date',
                                        e.target.checked
                                    )
                                }}
                                disabled={this.props.disabled}
                            />
                        }
                        label={this.props.kedo.t(
                            'Use current date/time as default value'
                        )}
                        sx={{
                            mb: 0,
                            '& .MuiFormControlLabel-label': {
                                fontSize: '0.875rem',
                                color: 'text.primary',
                            },
                        }}
                    />
                </FormControl>
            </div>
        )
    }
}

export default DisplayItemDateSettings
